module.exports = "/remote-dist/dc479867c31740d055355499486c9b66.png";